"use client";

import {
  Tool,
  ToolContent,
  ToolHeader,
  ToolOutput,
} from "@/components/ai-elements/tool";
import type { ChatToolEvent } from "@/lib/ai/chat-ui";

export function ChatToolCard({ event }: { event: ChatToolEvent }) {
  const failed = event.status === "error";

  return (
    <Tool className="mb-0" defaultOpen={failed}>
      <ToolHeader
        title={event.label}

        type={`tool-${event.serverName || event.label}`}
        state={
          event.status === "start"
            ? "input-available"
            : failed
              ? "output-error"
              : "output-available"
        }
      />
      {/*
        只在有话可说时才渲染内容区。成功时服务端不下发工具返回值
        （见 lib/ai/agent/run 的事件定义），此时卡片就是一行回执
      */}
      {event.message ? (
        <ToolContent>
          <ToolOutput
            output={failed ? undefined : event.message}
            errorText={failed ? event.message : undefined}
          />
        </ToolContent>
      ) : null}
    </Tool>
  );
}
